
/**
 * CookieHelper class for managing cookies
 */
export class CookieHelper {
    /**
     * Gets a cookie value by name
     * @param cookieName - The name of the cookie to retrieve
     * @returns The cookie value or null if not found
     */
    static getCookie(cookieName: string): string | null {
        try {
            const name = cookieName + "=";
            const decodedCookie = decodeURIComponent(document.cookie);
            const cookieArray = decodedCookie.split(';');

            for (let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) === ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) === 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
        } catch (error) {
            console.error('Failed to get cookie:', error);
        }
        return null;
    }

    /**
     * Clears a cookie by setting it to expire in the past
     * @param cookieName - The name of the cookie to clear
     * @param path - The path of the cookie (defaults to '/')
     * @param sameSite - The SameSite attribute (defaults to 'None')
     * @param secure - Whether to include the Secure attribute (defaults to true for SameSite=None)
     * @param domain - The domain of the cookie (e.g., '.test.com' to clear cookies set on parent domain)
     */
    static clearCookie(
        cookieName: string,
        path: string = '/',
        sameSite: string = 'None',
        secure: boolean = true,
        domain?: string
    ): void {
        try {
            // Build cookie string - Secure attribute is required when using SameSite=None
            const secureAttr = secure ? ' Secure;' : '';
            const domainAttr = domain ? ` domain=${domain};` : '';
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; SameSite=${sameSite};${secureAttr}${domainAttr}`;
        } catch (error) {
            console.error('Failed to clear cookie:', error);
        }
    }
}
